'use client';

import React from 'react';

export default function AIPositioning() {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-5xl mx-auto">
        <div className="reveal-blur bento-card card-shine relative p-10 md:p-16 overflow-hidden">
          {/* Big quote mark */}
          <div
            className="absolute -top-8 -left-2 font-manrope font-extrabold text-[240px] leading-none pointer-events-none select-none"
            style={{
              background: 'linear-gradient(180deg, rgba(124,58,237,0.25), rgba(124,58,237,0))',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            &ldquo;
          </div>

          {/* Glow */}
          <div
            className="absolute -top-20 -right-20 w-80 h-80 rounded-full pointer-events-none"
            style={{
              background: 'radial-gradient(circle, rgba(124,58,237,0.2) 0%, transparent 70%)',
              filter: 'blur(40px)',
            }}
          />

          <div className="relative z-10">
            <div className="text-[10px] font-mono text-[#A78BFA] tracking-widest uppercase mb-6">
              Positioning Statement
            </div>
            <p
              className="font-manrope font-bold tracking-tight text-[#EEEEF0] leading-snug"
              style={{ fontSize: 'clamp(1.35rem, 2.8vw, 2.25rem)' }}
            >
              &ldquo;MRI and Yardi are great accounting tools that{' '}
              <span className="text-[#9999A8]">added AI chatbots</span>. AppFolio is a great residential PM tool that{' '}
              <span className="text-[#9999A8]">added agents</span>. Propmatic is an{' '}
              <span
                style={{
                  background: 'linear-gradient(135deg, #7C3AED, #A78BFA)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                AI-native operating system for real estate
              </span>{' '}
              where every workflow runs itself by default — and humans step in only for decisions that require judgment.&rdquo;
            </p>
            <div className="mt-8 flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-[rgba(124,58,237,0.2)] border border-[rgba(124,58,237,0.4)] flex items-center justify-center">
                <span className="font-manrope font-bold text-xs text-[#A78BFA]">PF</span>
              </div>
              <div>
                <div className="font-manrope font-semibold text-sm text-[#EEEEF0]">Propmatic Manifesto</div>
                <div className="text-[10px] font-mono text-[#5A5A6E]">April 2026 · v1.0</div>
              </div>
            </div>
          </div>

          <div className="scan-line" />
        </div>
      </div>
    </section>
  );
}
